import React from 'react';
const NoUserSVG = ({ className, onClick, ...props }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='154'
      height='130'
      viewBox='0 0 154 130'
      fill='none'
      className={className}
      {...props}
      onClick={onClick}
    >
      <ellipse
        cx='75.5418'
        cy='66.2712'
        rx='63.7294'
        ry='63.7288'
        fill='#E6F3FD'
      />
      <path
        d='M132.261 29.8944C130.347 27.2164 127.475 27.4544 126.458 30.7275C124.184 37.9879 117.064 40.666 112.697 41.3206C110.184 22.6935 94.1497 8.35121 74.7649 8.35121C55.4399 8.35121 39.4654 22.634 36.8928 41.1421C32.4654 40.3089 26.0038 37.5714 23.8499 30.668C22.8328 27.3949 19.961 27.2164 18.0465 29.8349C14.1575 35.1909 15.7729 42.0347 18.1661 47.6288C21.6961 56.139 28.5166 62.2091 36.5338 66.3154C36.3543 76.3729 35.6364 84.5855 32.8244 95.1785C31.8671 98.8087 31.0295 101.784 30.2517 103.748C29.7132 105.117 29.3543 106.486 30.1919 107.854C31.6278 110.175 34.4398 110.89 37.0124 111.306C39.4056 111.723 41.4398 111.901 43.115 111.961C47.1835 112.08 48.9783 111.485 48.9783 111.485C48.9783 111.485 49.2775 111.961 50.0553 112.615C52.269 114.579 58.4314 118.388 72.3119 117.852C89.6026 117.198 96.2437 115.531 99.295 112.913C99.5343 112.675 99.7736 112.496 99.9531 112.258C101.868 112.258 103.603 112.318 105.158 112.318C110.603 112.377 114.492 112.496 117.603 111.366C120.056 110.473 121.611 107.616 120.056 104.581C115.389 95.4166 112.996 85.2996 112.996 75.0041V66.6725C121.312 62.5662 128.492 56.4365 132.141 47.6288C134.535 42.0347 136.15 35.1909 132.261 29.8944Z'
        fill='#E6F3FD'
        stroke='#B9DBFA'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinejoin='round'
      />
      <path
        d='M105.215 112.199C103.599 112.199 101.864 112.139 100.01 112.139C99.8301 112.377 99.5908 112.615 99.3515 112.794C97.6164 105.117 96.1207 97.2612 95.7617 87.6203C98.2147 95.8924 101.326 105.652 105.215 112.199Z'
        fill='#B9DBFA'
      />
      <path
        d='M50.0535 112.556C49.2757 111.901 48.9766 111.425 48.9766 111.425C48.9766 111.425 47.1817 112.08 43.1133 111.901C46.5236 105.653 49.5749 93.9288 49.2159 86.6684C49.7544 99.4634 49.9339 107.497 50.0535 112.556Z'
        fill='#B9DBFA'
      />
      <path
        d='M60.5828 51.6754C63.4245 51.6754 65.7282 49.384 65.7282 46.5574C65.7282 43.7308 63.4245 41.4394 60.5828 41.4394C57.7411 41.4394 55.4375 43.7308 55.4375 46.5574C55.4375 49.384 57.7411 51.6754 60.5828 51.6754Z'
        fill='#8CC2F6'
      />
      <path
        d='M86.3103 54.3534C90.639 54.3534 94.148 50.863 94.148 46.5574C94.148 42.2518 90.639 38.7614 86.3103 38.7614C81.9817 38.7614 78.4727 42.2518 78.4727 46.5574C78.4727 50.863 81.9817 54.3534 86.3103 54.3534Z'
        fill='#8CC2F6'
      />
      <path
        d='M88.3439 61.5544C88.3439 63.5183 81.5233 65.1251 73.1472 65.1251C64.7112 65.1251 57.8906 63.5183 57.8906 61.5544H88.3439Z'
        fill='#8CC2F6'
      />
      <path
        d='M76.6758 78.6936C72.7869 78.6936 69.6758 75.5395 69.6758 71.7307V63.3991H83.7357V71.7307C83.7357 75.5395 80.5648 78.6936 76.6758 78.6936Z'
        fill='#8CC2F6'
      />
      <ellipse
        cx='15.8069'
        cy='23.2405'
        rx='3.99443'
        ry='3.9944'
        fill='#E6F3FD'
      />
      <ellipse
        cx='119.12'
        cy='7.44411'
        rx='7.44417'
        ry='7.44411'
        fill='#E6F3FD'
      />
      <ellipse
        cx='7.08104'
        cy='102.939'
        rx='7.08104'
        ry='7.08098'
        fill='#E6F3FD'
      />
      <ellipse
        cx='143.815'
        cy='100.404'
        rx='7.08104'
        ry='7.08098'
        fill='#E6F3FD'
      />
      <ellipse
        cx='130.016'
        cy='108.394'
        rx='3.44974'
        ry='3.44971'
        fill='#E6F3FD'
      />
      <path
        d='M23.7409 118.539C23.4249 118.471 23.4249 118.02 23.7409 117.953L27.8221 117.076C27.9375 117.051 28.0276 116.961 28.0524 116.846L28.9288 112.765C28.9966 112.449 29.4475 112.449 29.5154 112.765L30.3918 116.846C30.4165 116.961 30.5067 117.051 30.6221 117.076L34.7032 117.953C35.0192 118.02 35.0192 118.471 34.7032 118.539L30.6221 119.416C30.5067 119.44 30.4165 119.531 30.3918 119.646L29.5154 123.727C29.4475 124.043 28.9966 124.043 28.9288 123.727L28.0524 119.646C28.0276 119.531 27.9375 119.44 27.8221 119.416L23.7409 118.539Z'
        fill='#B9DBFA'
      />
      <path
        d='M34.1853 5.18954C34.2532 4.86861 34.7113 4.86861 34.7792 5.18954L35.3403 7.8403C35.3651 7.95714 35.456 8.04862 35.5727 8.07404L38.2046 8.64739C38.5232 8.71679 38.5232 9.17118 38.2046 9.24059L35.5727 9.81394C35.456 9.83936 35.3651 9.93084 35.3403 10.0477L34.7792 12.6984C34.7113 13.0194 34.2532 13.0194 34.1853 12.6984L33.6242 10.0477C33.5995 9.93084 33.5085 9.83936 33.3918 9.81394L30.7599 9.24059C30.4414 9.17118 30.4414 8.71679 30.7599 8.64739L33.3918 8.07404C33.5085 8.04862 33.5995 7.95714 33.6242 7.8403L34.1853 5.18954Z'
        fill='#B9DBFA'
      />
      <path
        d='M118.463 20.0061C118.585 19.4284 119.41 19.4284 119.532 20.0061L120.036 22.3885C120.081 22.5988 120.245 22.7635 120.455 22.8093L122.837 23.3283C123.411 23.4532 123.411 24.2712 122.837 24.3961L120.455 24.9151C120.245 24.9609 120.081 25.1256 120.036 25.3359L119.532 27.7183C119.41 28.296 118.585 28.296 118.463 27.7183L117.959 25.3359C117.914 25.1256 117.75 24.9609 117.54 24.9151L115.158 24.3961C114.584 24.2712 114.584 23.4532 115.158 23.3283L117.54 22.8093C117.75 22.7635 117.914 22.5988 117.959 22.3885L118.463 20.0061Z'
        fill='#B9DBFA'
      />
      <path
        d='M147.138 78.5558L148.25 83.8093L153.429 84.9375L148.25 86.0656L147.138 91.3191L146.026 86.0656L140.848 84.9375L146.026 83.8093L147.138 78.5558Z'
        fill='white'
      />
    </svg>
  );
};

export default NoUserSVG;
